// extracted by mini-css-extract-plugin
export default {"grid":"ProjectThumbnailsV4Grid_grid__DxWWG"};